import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'testid', standalone: true, pure: true })
export class DataTestIdPipe implements PipeTransform {
    transform(
        input: string,
        prefix: string,
        suffix: string | undefined = undefined,
    ): string {
        return input.length === 0
            ? ''
            : `${prefix ? prefix : 'rcp'}-${input}${suffix ? `-${suffix}` : ''}`;
    }
}
